import { karateR0Fetch } from "./karateR0ApiClient.js";

export async function fetchLaunchCockpit() {
  const { response, body } = await karateR0Fetch("/admin/launch-cockpit");
  return { ok: response.ok, status: response.status, body };
}

export async function updateLaunchOutcome(outcomeId, status) {
  const { response, body } = await karateR0Fetch(`/admin/launch-cockpit/outcomes/${outcomeId}`, {
    method: "PATCH",
    body: JSON.stringify({ status }),
  });
  return { ok: response.ok, status: response.status, body };
}

export async function updateLaunchChecklist(checklistId, status) {
  const { response, body } = await karateR0Fetch(`/admin/launch-cockpit/checklist/${checklistId}`, {
    method: "PATCH",
    body: JSON.stringify({ status }),
  });
  return { ok: response.ok, status: response.status, body };
}

export async function setLaunchExpandedStep(stepId) {
  const { response, body } = await karateR0Fetch("/admin/launch-cockpit/expanded-step", {
    method: "PATCH",
    body: JSON.stringify({ stepId }),
  });
  return { ok: response.ok, status: response.status, body };
}

export async function updateLaunchDependency(id, patch) {
  const { response, body } = await karateR0Fetch(`/admin/launch-cockpit/dependencies/${id}`, {
    method: "PATCH",
    body: JSON.stringify(patch),
  });
  return { ok: response.ok, status: response.status, body };
}

export async function addLaunchPhase2Idea(payload) {
  const { response, body } = await karateR0Fetch("/admin/launch-cockpit/phase2-ideas", {
    method: "POST",
    body: JSON.stringify(payload),
  });
  return { ok: response.ok, status: response.status, body };
}

export async function removeLaunchPhase2Idea(id) {
  const { response, body } = await karateR0Fetch(`/admin/launch-cockpit/phase2-ideas/${id}`, {
    method: "DELETE",
  });
  return { ok: response.ok, status: response.status, body };
}
